export default "__VITE_ASSET__2oaaBiIM__"